<template>
  <div class="pedido scrollPedido" id="style-1">
    <div class="pedido1">
    <div class="pedido">
      <h3><i class="icon-cart"></i> Informacion del pedido</h3>

      <section class="border">
        <h3>Cliente</h3>
        <ul>
          <li>{{ datos.nombre }} {{ datos.apellido }}</li>
          <li>{{ datos.mail_d ? datos.mail_d : "-" }}</li>
          <li>{{ datos.telefono }}</li>
        </ul>
      </section>
      <section>
        <table class="table">
          <tr class="mb10">
            <th style="padding-bottom: 1px">Pedido</th>
            <th style="padding-bottom: 1px">n° {{ datos.vtex_id }}</th>
          </tr>

          <tr>
            <td>Bultos/paquetes</td>
            <th>{{ datos.bultos || 1 }}</th>
          </tr>
          <tr>
            <td>Fecha de compra</td>
            <th>
              {{
                datos.vtex_fecha
                  ? $date(datos.vtex_fecha.date).format("DD/MM/YY HH:mm")
                  : "-"
              }}
            </th>
          </tr>
          <tr>
            <td>Importe abonado</td>
            <th>{{ (datos.importe / 100) | currency }}</th>
          </tr>
           <tr v-if="datos.facturas.length">
            <td>Ver factura</td>
            <th >
              <a  v-for="f in datos.facturas" :key="f.factura" :href="f.url_factura"  style="margin-bottom:0px; display:inline-block" target="_blank">{{f.factura}}</a>
            </th>
          </tr>
           <tr v-if="datos.palabra">
            <td style="background:#f5f5f5  !important; color:#000; padding:6px 1px ">Palabra Clave</td>
            <th style="background:#f5f5f5  !important; color:#000; padding:6px 1px ">
              {{datos.palabra.toUpperCase()}}
            </th>
          </tr>
        </table>
        <a href="#" @click.prevent="goToMenu('productos')">Más detalles del pedido</a>
      </section>
    </div>
    <section class="estado">
      <h3>Estado</h3>
      <div v-html="getEstadoPedido(datos).titulo"></div>
      
      <!-- <el-button
        type="default"
        v-if="datos.sc_ultimo_estado == 32"
        class="btn-estado"
        size="mini"
        @click="noretira"
        >No voy a retirar mi pedido
      </el-button> -->

      <a
        href="#"
        v-if="getEstadoPedido(datos).btnEnvio"
        @click.prevent="goToMenu('entrega')"
        >Seguir envío
      </a>
    </section>
    <section class="entrega"  v-if="datos.sc_ultimo_estado != 32">
      <h3>Entrega</h3>
      <PuntoRetiro :datos="datos" />
    </section>
  </div>
  </div>
</template>

<script>
import estadosMixins from "@/mixins/estadosMixins.js";
export default {
  props: ["datos"],
  mixins: [estadosMixins],
  name: "pedido",
  components: {
    PuntoRetiro: () => import("@/components/puntoRetiro"),
  },
  methods: {
    noretira() {
     
    },
  },
};
</script>

<style lang="scss" scoped>
.scrollPedido{
margin: 0px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  height: 450px;
  margin-bottom: 0;
}
.pedido {
  padding: 0px 10px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.pedido h3 {
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  text-align: left;
  color: #222;
  margin-bottom: 0;
}
.pedido section a {
  color: #BFBE51;
  display: block;
  text-align: left;
  font-size: 13.5px;
  font-weight: 700;
  margin-bottom: 25px;
  letter-spacing: 0.1px;
}
.entrega {
  padding: 0px 10px;
  position: relative;
}
.estado {
  background-color: #f7f6cf;
  text-align: left;
  padding: 1px 10px;
  font-size: 13.5px;
}
.border {
  border-bottom: 1px solid #f1f1f1;
}
.pedido section h3 {
  color: #333333;
  font-size: 13.5px;
  margin-bottom: 0px;
}

.pedido section ul {
  list-style: none;
  text-align: left;
  padding: 0;
  font-size: 13.5px;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
  margin-top: 0px;
}
.pedido section table {
  margin-top: 10px;
  margin-bottom: 10px;
}
.pedido section table > tr > td,
.pedido section table > tr > th {
  color: #333333;
  text-align: left;
  font-size: 13.5px;
}
.btn-estado{
  background-color:#BFBE51;
  border-color: #BFBE51;
  font-family: 'Montserrat', sans-serif;
  color:white;
  margin-bottom: 20px;
  font-size: 13.5px;
  // float: right;
  cursor: pointer;
  margin-left: 30px;
}
@media screen and (max-width:768px) {
  .scrollPedido{
margin: 0px;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 100vh;
  // margin-bottom: 100px;
}

.pedido1{
   margin-bottom: 150px;
  // height: 150vh;

}
}
</style>
